var _style, _defs, _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeedLoader(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo-n",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 91.100000 112.420000",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "#logo-n-layer-2_to {animation: logo-n-layer-2_to__to 3000ms linear infinite normal forwards}@keyframes logo-n-layer-2_to__to { 0% {transform: translate(45.550000px,85.905121px)} 50% {transform: translate(45.550000px,85.905121px)} 60% {transform: translate(45.550000px,76.856027px)} 63.333333% {transform: translate(44.890970px,72.092006px)} 70% {transform: translate(45.550000px,84.905121px)} 80% {transform: translate(45.550000px,84.905121px)} 86.666667% {transform: translate(45.550001px,75.017032px)} 90% {transform: translate(45.301399px,71.112132px)} 100% {transform: translate(45.550000px,84.797317px)} }#logo-n-layer-2_tr {animation: logo-n-layer-2_tr__tr 3000ms linear infinite normal forwards}@keyframes logo-n-layer-2_tr__tr { 0% {transform: rotate(0deg)} 60% {transform: rotate(0deg)} 63.333333% {transform: rotate(-2.836138deg)} 76.666667% {transform: rotate(0deg)} 86.666667% {transform: rotate(0deg)} 90% {transform: rotate(0deg)} 100% {transform: rotate(0deg)} }#logo-n-layer-2_ts {animation: logo-n-layer-2_ts__ts 3000ms linear infinite normal forwards}@keyframes logo-n-layer-2_ts__ts { 0% {transform: scale(0.500000,0.500000)} 10% {transform: scale(0.500000,0.480000)} 20% {transform: scale(0.500000,0.500000)} 30% {transform: scale(0.500000,0.480000)} 40% {transform: scale(0.500000,0.500000)} 50% {transform: scale(0.500000,0.480000)} 60% {transform: scale(0.500000,0.500000)} 63.333333% {transform: scale(0.500000,0.450000)} 66.666667% {transform: scale(0.500000,0.500000)} 70% {transform: scale(0.500000,0.500000)} 80% {transform: scale(0.500000,0.480000)} 86.666667% {transform: scale(0.500000,0.480000)} 90% {transform: scale(0.500000,0.450000)} 93.333333% {transform: scale(0.500000,0.480000)} 100% {transform: scale(0.500000,0.480000)} }#logo-n-circle2_to {animation: logo-n-circle2_to__to 3000ms linear infinite normal forwards}@keyframes logo-n-circle2_to__to { 0% {transform: translate(61.590000px,19.030001px)} 50% {transform: translate(61.590000px,19.030001px)} 60% {transform: translate(61.590000px,29.030001px)} 70% {transform: translate(61.590000px,29.030001px)} 93.333333% {transform: translate(61.590000px,29.030001px)} 100% {transform: translate(61.590000px,19.030001px)} }#logo-n-half-crkl_tr {animation: logo-n-half-crkl_tr__tr 3000ms linear infinite normal forwards}@keyframes logo-n-half-crkl_tr__tr { 0% {transform: translate(45.550000px,57.285001px) rotate(0deg)} 50% {transform: translate(45.550000px,57.285001px) rotate(182.078547deg)} 100% {transform: translate(45.550000px,57.285001px) rotate(360.400313deg)} }")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-n-circle1-fill",
    x1: -42.71,
    y1: 0,
    x2: 42.71,
    y2: 0,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "logo-n-circle1-fill-0",
    offset: "0%",
    stopColor: "rgb(57,54,140)"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "logo-n-circle1-fill-1",
    offset: "50%",
    stopColor: "rgb(27,99,170)"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "logo-n-circle1-fill-2",
    offset: "99%",
    stopColor: "rgb(0,139,197)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-n-rect1-fill",
    x1: 10.15,
    y1: 99.16,
    x2: 85.68,
    y2: 7.51,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "logo-n-rect1-fill-0",
    offset: "0%",
    stopColor: "rgb(70,0,220)"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "logo-n-rect1-fill-1",
    offset: "50%",
    stopColor: "rgb(17,84,250)"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "logo-n-rect1-fill-2",
    offset: "99%",
    stopColor: "rgb(0,190,255)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo-n-bg_crkl",
    transform: "matrix(1 0 0 1 2.84000091999999 14.57500094000002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo-n-eoba2f22riqo1"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "logo-n-circle1",
    r: 42.71,
    transform: "matrix(1 0 0 1 42.70999908000000 42.71000000000000)",
    opacity: 0.2,
    fill: "url(#logo-n-circle1-fill)",
    fillOpacity: 0.51,
    stroke: "none",
    strokeWidth: 1
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "logo-n-layer-2_to",
    transform: "translate(45.550000,85.905121)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo-n-layer-2_tr",
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo-n-layer-2_ts",
    transform: "scale(0.500000,0.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo-n-layer-2",
    transform: "translate(-45.550000,-112.390243)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo-n-layer-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo-n-g1",
    clipPath: "url(#logo-n-clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo-n-g2",
    transform: "matrix(1 0 0 1.05860310622841 0 -1.29408054744592)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo-n-g3",
    clipPath: "url(#logo-n-clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo-n-g4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "logo-n-rect1",
    width: 91.1,
    height: 112.42,
    rx: 0,
    ry: 0,
    transform: "matrix(1 0 0 1 0 -3.37666575113933)",
    fill: "url(#logo-n-rect1-fill)",
    stroke: "none",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "logo-n-clip-path-2",
    transform: "matrix(1 0 0 1 1.26000000000000 0.15000000000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "logo-n-rect2",
    width: 90.86,
    height: 112.71,
    rx: 0,
    ry: 0,
    transform: "matrix(1 0 0 1 -0.17000000000000 -0.29000000000000)",
    fill: "none",
    stroke: "none",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("clipPath", {
    id: "logo-n-clip-path",
    transform: "matrix(1 0 0 1 1.26000000000000 -1.85000000000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "logo-n-path1",
    d: "M38.800000,31.090000C38.795955,22.381019,44.039006,14.527331,52.083894,11.191745C60.128783,7.856159,69.390859,9.695706,75.550470,15.852455C81.710080,22.009205,83.553929,31.270426,80.222081,39.316863C76.890233,47.363300,69.038982,52.609999,60.330000,52.610000C48.443213,52.610001,38.805521,42.976785,38.800000,31.090000M2.700000,0L2.700000,0C2.640407,-0.009885,2.579593,-0.009885,2.520000,0C1.896206,0.087054,1.324649,0.395908,0.910000,0.870000L0.110000,1.590000C0.036425,1.985755,-0.000398,2.387465,0,2.790000C0,7.530000,5.310000,8,5.310000,8C8.368262,8.724842,10.471971,11.531191,10.310000,14.670000C10.314894,15.244450,10.257899,15.817757,10.140000,16.380000C9.676526,17.285164,9.423561,18.283351,9.400000,19.300000C9.400000,23.030000,13.660000,24.300000,13.660000,24.300000C15.937639,25.351339,17.386155,27.641561,17.360000,30.150000C17.353050,31.303270,17.111482,32.443064,16.650000,33.500000C15.778110,34.522241,15.274554,35.807542,15.220000,37.150000C15.220000,40.220000,18.460000,41.970000,18.460000,41.970000C20.026043,43.174396,20.960432,45.024780,21,47C20.948145,48.635628,20.412199,50.219104,19.460000,51.550000C18.110739,52.523124,17.278730,54.058290,17.200000,55.720000C17.343096,57.452963,18.153344,59.062704,19.460000,60.210000C20.446180,61.402887,21.002658,62.892700,21.040000,64.440000C20.922691,66.508290,19.991544,68.446082,18.450000,69.830000C15.980000,71.170000,15.270000,72.830000,15.270000,74.400000C15.336234,75.805850,15.812477,77.161577,16.640000,78.300000C17.146456,79.302701,17.419926,80.406833,17.440000,81.530000C17.440000,85.450000,13.650000,87.530000,13.650000,87.530000C10.290000,88.530000,9.490000,90.670000,9.490000,92.470000C9.500783,93.502713,9.718401,94.522795,10.130000,95.470000C10.293018,96.124269,10.376951,96.795734,10.380000,97.470000C10.380000,102.380000,5.300000,103.880000,5.300000,103.880000C0.770000,104.230000,0.050000,107.340000,0.050000,109.290000C0.044710,109.790184,0.091630,110.289555,0.190000,110.780000L0.900000,111.420000C1.370678,111.853226,1.958414,112.138400,2.590000,112.240000L2.690000,112.240000L2.690000,112.240000L58.400000,112.240000C71.784521,112.291988,83.780013,103.988098,88.443666,91.442245C93.107320,78.896392,89.448556,64.773365,79.280000,56.070000C89.369085,47.350122,92.974329,33.277335,88.320638,20.780573C83.666948,8.283810,71.735138,-0.003107,58.400000,0Z",
    fill: "none",
    stroke: "none",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "logo-n-g5",
    clipPath: "url(#logo-n-clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo-n-g6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo-n-g7",
    clipPath: "url(#logo-n-clip-path-4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo-n-g8"
  }, /*#__PURE__*/React.createElement("image", {
    id: "logo-n-image1",
    width: 4,
    height: 31,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAfCAYAAADA4GwmAAAACXBIWXMAAAsSAAALEgHS3X78AAAARElEQVQoU2O8fuP6f0ZGRgYGBgYGRkZGBiYGNEBnAZhbSNBCVQGY/bhVMDAgXImhAnsQEmcoAwOa91HiBacZ+EOMNDMAmc8D8x4wIDMAAAAASUVORK5CYII=",
    preserveAspectRatio: "xMidYMid meet",
    transform: "matrix(0 -0.29000000000000 0.29000000000000 0 57.01000000000000 53.15000000000000)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "logo-n-clip-path-4",
    transform: "matrix(1 0 0 1 1.26000000000000 0.15000000000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "logo-n-rect3",
    width: 9.03,
    height: 1.16,
    rx: 0,
    ry: 0,
    transform: "matrix(1 0 0 1 55.75000000000000 51.84000000000000)",
    fill: "none",
    stroke: "none",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("clipPath", {
    id: "logo-n-clip-path-3",
    transform: "matrix(1 0 0 1 1.26000000000000 0.15000000000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "logo-n-path2",
    d: "M56.150000,52.210000C58.911053,52.744333,61.748947,52.744333,64.510000,52.210000Z",
    fill: "none",
    stroke: "none",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "logo-n-g9",
    clipPath: "url(#logo-n-clip-path-5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo-n-g10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo-n-g11",
    clipPath: "url(#logo-n-clip-path-6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo-n-g12"
  }, /*#__PURE__*/React.createElement("image", {
    id: "logo-n-image2",
    width: 148,
    height: 150,
    xlinkHref: "data:image/png;base64,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",
    preserveAspectRatio: "xMidYMid meet",
    transform: "matrix(0 -0.29000000000000 0.29000000000000 0 40.06000000000000 52.57000000000000)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "logo-n-clip-path-6",
    transform: "matrix(1 0 0 1 1.26000000000000 0.15000000000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "logo-n-rect4",
    width: 43.68,
    height: 43.1,
    rx: 0,
    ry: 0,
    transform: "matrix(1 0 0 1 38.57000000000000 9.32000000000000)",
    fill: "none",
    stroke: "none",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("clipPath", {
    id: "logo-n-clip-path-5",
    transform: "matrix(1 0 0 1 1.26000000000000 0.15000000000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "logo-n-path3",
    d: "M38.800000,31.090000C38.804078,41.367661,46.068660,50.210771,56.150000,52.210000L64.510000,52.210000C75.640844,50.007055,83.151488,39.543615,81.677589,28.293003C80.203691,17.042391,70.251212,8.866725,58.928531,9.605328C47.605849,10.343931,38.799824,19.743254,38.800000,31.090000",
    fill: "none",
    stroke: "none",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "logo-n-circle2_to",
    transform: "translate(61.590000,19.030001)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "logo-n-circle2",
    r: 6.33,
    transform: "translate(-0,-0.000001)",
    fill: "rgb(29,29,27)",
    stroke: "none",
    strokeWidth: 1
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "logo-n-half-crkl_tr",
    transform: "translate(45.550000,57.285001) rotate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo-n-half-crkl",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    },
    transform: "translate(-45.550000,-57.285001)"
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "logo-n-eoba2f22riqo12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "logo-n-path4",
    d: "M15.560000,76.390000L16.140000,75.560000C-0.722070,61.452339,-3.927791,36.762235,8.772487,18.816249C21.472766,0.870262,45.823466,-4.318310,64.736208,6.891671C83.648950,18.101652,90.786500,41.953974,81.140000,61.710000L82.140000,61.970000C91.914748,41.708404,84.508105,17.336696,65.112333,5.940117C45.716561,-5.456461,20.821446,-0.064639,7.879152,18.335769C-5.063142,36.736176,-1.722150,61.988429,15.560000,76.390000Z",
    transform: "matrix(0.97967321460422 0.20060008122391 -0.20060008122391 0.97967321460422 11.96290495278906 6.71634626130164)",
    fill: "rgb(3,70,158)",
    stroke: "none",
    strokeWidth: 3,
    strokeLinecap: "round"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedLoader);
export default __webpack_public_path__ + "static/media/feed-loader.7de9a2bb.svg";
export { ForwardRef as ReactComponent };